import * as React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Avatar,
  Button,
  Tooltip,
  MenuItem,
  ListItemIcon,
  // ListSubheader,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import GradingIcon from "@mui/icons-material/Grading";
import LoginIcon from "@mui/icons-material/Login";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Dashboard from "@mui/icons-material/Dashboard";
// import Settings from "@mui/icons-material/Settings";
import FileDownload from "@mui/icons-material/FileDownload";
import Report from "@mui/icons-material/Report";
import ReportProblem from "@mui/icons-material/ReportProblem";
import Checklist from "@mui/icons-material/Checklist";
import Computer from "@mui/icons-material/Computer";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import EditDocument from "@mui/icons-material/EditDocument";
// import InfoIcon from "@mui/icons-material/Info";
import Note from "@mui/icons-material/Note";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
// import { styled } from "@mui/material/styles";

// const StyledListHeader = styled(ListSubheader)({
//   backgroundImage: "var(--Paper-overlay)",
// });

const pages = [
  {
    page: "Projects",
    icon: <Note color="primary" />,
    iconButton: <Note color="#FFFFFF" />,
  },
  {
    page: "Dashboard",
    icon: <Dashboard color="primary" />,
    iconButton: <Dashboard color="#FFFFFF" />,
  },
  {
    page: "Assets",
    icon: <Computer color="primary" />,
    iconButton: <Computer color="#FFFFFF" />,
  },
  {
    page: "Checklists",
    icon: <Checklist color="primary" />,
    iconButton: <Checklist color="#FFFFFF" />,
    children: [
      {
        page: "Checklists",
        icon: <Checklist color="primary" />,
        iconButton: <Checklist color="#FFFFFF" />,
      },
      {
        page: "Checklist Templates",
        icon: <GradingIcon color="primary" />,
        iconButton: <GradingIcon color="#FFFFFF" />,
      },
    ],
  },

  // { page: "Tests", icon: <EditDocument color="primary" /> },
  {
    page: "Issues",
    icon: <ReportProblem color="primary" />,
    iconButton: <ReportProblem color="#FFFFFF" />,
  },
  {
    page: "Observations",
    icon: <Report color="primary" />,
    iconButton: <Report color="#FFFFFF" />,
  },
  {
    page: "Files",
    icon: <FileDownload color="primary" />,
    iconButton: <FileDownload color="#FFFFFF" />,
  },
];

const settings = [
  { page: "Account", icon: <AccountCircle color="primary" /> },
  // { page: "Account", icon: <Settings color="primary" /> },
  { page: "Logout", icon: <LogoutIcon color="primary" /> },
];

const ResponsiveAppBar = ({ user, currentProject, userData }) => {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (page) => {
    if (page === "Projects") {
      navigate(`/`);
    } else if (page === null) {
      // navigate(`/`); do nothing
    } else {
      const currentPath = window.location.pathname.split("/");
      // console.log(currentPath);
      navigate(
        `/project/${currentPath[2]}/${page.replace(/ /g, "-").toLowerCase()}`,
        { state: { passProject: currentProject } },
      );
    }
    setAnchorElNav(null);
    setAnchorEl(null);
  };

  const handleCloseUserMenu = (setting) => {
    // console.log(setting);
    if (setting === null) {
    } else if (setting === "Logout") {
      signOut(auth);
      navigate(`/`);
    } else {
      navigate(`/${setting.toLowerCase()}`);
    }
    setAnchorElUser(null);
  };

  return (
    <AppBar color="primary" position="fixed">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* <EditDocument sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            BECx GO
          </Typography> */}

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={() => handleCloseNavMenu(null)}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {window.location.href.toLowerCase().includes("project/")
                ? pages.map((page) =>
                    page.page === "Checklists" ? (
                      // [
                      // <ListSubheader key={page.page}>
                      //   {/* <ListItemIcon>{page.icon}</ListItemIcon> */}
                      //   <Typography color="secondary" textAlign="top">
                      //     {page.page}
                      //   </Typography>
                      // </ListSubheader>,
                      page.children.map((f) => (
                        <MenuItem
                          key={f.page}
                          onClick={() => handleCloseNavMenu(f.page)}
                        >
                          <ListItemIcon>{f.icon}</ListItemIcon>
                          <Typography color="primary" textAlign="center">
                            {f.page}
                          </Typography>
                        </MenuItem>
                      ))
                    ) : (
                      // ]
                      <MenuItem
                        key={page.page}
                        onClick={() => handleCloseNavMenu(page.page)}
                      >
                        <ListItemIcon>{page.icon}</ListItemIcon>
                        <Typography color="primary" textAlign="center">
                          {page.page}
                        </Typography>
                      </MenuItem>
                    ),
                  )
                : pages
                    .filter((p) => p.page === "Projects")
                    .map((page) => (
                      <MenuItem
                        key={page.page}
                        onClick={() => handleCloseNavMenu(page.page)}
                      >
                        <ListItemIcon>{page.icon}</ListItemIcon>
                        <Typography color="primary" textAlign="center">
                          {page.page}
                        </Typography>
                      </MenuItem>
                    ))}
            </Menu>
          </Box>
          {/* <EditDocument sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} />
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            BECx GO
          </Typography> */}
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {window.location.href.toLocaleLowerCase().includes("project/")
              ? pages.map((p) =>
                  p.page === "Checklists" ? (
                    <div key={p.page}>
                      <Button
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                        sx={{ my: 2, color: "white" }}
                        endIcon={<KeyboardArrowDownIcon />}
                        startIcon={p.iconButton}
                        disableElevation
                      >
                        {p.page}
                      </Button>

                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        slotProps={{
                          list: {
                            "aria-labelledby": "basic-button",
                          },
                        }}
                      >
                        {p.children.map((fd) => (
                          <MenuItem onClick={() => handleCloseNavMenu(fd.page)}>
                            <ListItemIcon>{fd.icon}</ListItemIcon>
                            {fd.page}
                          </MenuItem>
                        ))}
                      </Menu>
                    </div>
                  ) : (
                    <Button
                      key={p.page}
                      startIcon={p.iconButton}
                      onClick={() => handleCloseNavMenu(p.page)}
                      sx={{ my: 2, color: "white" }}
                    >
                      {p.page}
                    </Button>
                  ),
                )
              : pages
                  .filter((p) => p.page === "Projects")
                  .map((p) => (
                    <Button
                      key={p.page}
                      onClick={() => handleCloseNavMenu(p.page)}
                      sx={{ my: 2, color: "white", display: "block" }}
                    >
                      {p.page}
                    </Button>
                  ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="User menu">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  alt={user ? user.displayName : "User"}
                  src={`https://firebasestorage.googleapis.com/v0/b/becx-eb075.firebasestorage.app/o/users%2F${user?.uid || "default"}%2FprofilePic.jpg?alt=media`}
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={() => handleCloseUserMenu(null)}
            >
              {user ? (
                settings.map((setting) => (
                  <MenuItem
                    key={setting.page}
                    onClick={() =>
                      handleCloseUserMenu(
                        setting.page.replace("Edit Profile", "Profile"),
                      )
                    }
                  >
                    <ListItemIcon>{setting.icon}</ListItemIcon>
                    <Typography color="primary" textAlign="center">
                      {setting.page}
                    </Typography>
                  </MenuItem>
                ))
              ) : (
                <MenuItem onClick={() => handleCloseUserMenu("Profile")}>
                  <ListItemIcon>
                    <LoginIcon />
                  </ListItemIcon>

                  <Typography textAlign="center">Login</Typography>
                </MenuItem>
              )}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
